import React, { useState } from "react";
import ContentWrapper from "src/components/layouts/content-wrapper";
import SettingsHeader from "../settings-header";
import PersonalInformation from "../personal-information";

const GeneralSettingComponent = () => {
  const [toggle, setToggle] = useState(false);

  const onClick = () => {
    setToggle(!toggle);
  };

  return (
    <ContentWrapper>
      <div className="xl:gird-cols-12 general-settings grid">
        <SettingsHeader
          headingText="General Settings"
          subheadingText="Update your personal details here."
          showButton={true}
          buttonText={toggle ? "Cancel" : "Edit Information"}
          variant={toggle ? "secondary" : "primary"}
          onClick={onClick}
        />
        <div className="grid xl:grid-cols-12">
          <div className="xl:col-span-12 xxl:col-span-12">
            <PersonalInformation
              toggle={toggle}
              getToggle={(value: any) => setToggle(value)}
            />
          </div>
        </div>
      </div>
    </ContentWrapper>
  );
};

export default GeneralSettingComponent;
